/*
    A Vue 3 app, built using composables, utility classes
    and graphql queries from dottie/client-core

    Vue 3: https://vuejs.org/guide/introduction.html
    (select 'Composition' as your API preference)

    Config file:
    vite.config.dottie.js
*/
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './dottie/App.vue';

const pinia = createPinia();
const app = createApp(App);

app.use(pinia);
app.mount('.js-dottie-app');
